/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsAdvertisementOptions, FxIdDomainSettingsAdvertisementOptionsFromJSONTyped, FxIdDomainSettingsAdvertisementOptionsToJSON, } from './FxIdDomainSettingsAdvertisementOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementOptions(json)) {
        return FxIdDomainSettingsAdvertisementOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementOptions(value)) {
        return FxIdDomainSettingsAdvertisementOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisement.js.map